import { render, staticRenderFns } from "./SalesPerDayReportView.vue?vue&type=template&id=b60e300a&"
import script from "./SalesPerDayReportView.vue?vue&type=script&lang=ts&"
export * from "./SalesPerDayReportView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports